<template>
  <div>
    <v-app-bar
      flat
      color="transparent"
      class="main-appbar"
    >
      <app-bar-nav-icon />
      <div class="d-flex align-center">
        <v-toolbar-title>Welcome Promos</v-toolbar-title>
      </div>
      <v-spacer></v-spacer>
      <v-row
        v-if="showSearch"
        align="center"
        style="max-width: 300px;"
      >
        <v-text-field
          flat
          hide-details
          single-line
          label="Search by promo title"
          v-model="filter.search"
          @input="search"
        ></v-text-field>
      </v-row>
      <!-- <v-btn
        class="ml-5"
        icon
        @click="showSearch = !showSearch"
      >
        <img
          src="@/assets/icons/search.svg"
          alt
        />
      </v-btn>-->
    </v-app-bar>
    <div
      class="pa-4"
      id="best-promo-list"
    >
      <v-row>
        <v-col
          cols="12"
          md="3"
        >
          <v-autocomplete
            :items="states_option"
            clearable
            outlined
            label="State Filter"
            v-model="states_filter_id"
            @input="filterByState"
          ></v-autocomplete>
        </v-col>
        <v-col
          cols="12"
          md="3"
        >
          <v-autocomplete
            :items="states_option"
            clearable
            outlined
            label="Promo State Filter"
            v-model="promo_states_filter_id"
            @input="filterByPromoState"
          ></v-autocomplete>
        </v-col>
        <v-col
          cols="12"
          md="3"
        >
          <v-autocomplete
            :items="sportsbooks_option"
            clearable
            outlined
            label="SportsBook Filter"
            v-model="book_filter_id"
            @input="filterSportBooks()"
          ></v-autocomplete>
        </v-col>
        <v-col
          cols="12"
          md="3"
        >
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                large
                color="primary"
                v-bind="attrs"
                v-on="on"
                class="ml-3"
                @click="resetFilter"
              >
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
            </template>
            <span>Reset filter</span>
          </v-tooltip>
        </v-col>
      </v-row>
      <v-simple-table dense>
        <thead>
          <tr>
            <th></th>
            <th>SportsBook</th>
            <th>Bookmaker States</th>
            <th>Promo States</th>
            <th>Promo Title</th>
            <th>Priority</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(promo, i) in promoList"
            :key="i"
          >
            <td @click="updateDialog(promo, i)">
              <v-img
                v-if="promo.promo_logo"
                width="200"
                height="90"
                contain
                :src="promo.promo_logo.url"
              ></v-img>
              <v-img
                v-else-if="promo.bookmaker.logo"
                width="200"
                height="90"
                contain
                :src="promo.bookmaker.logo.url"
              ></v-img>
              <v-img
                v-else
                width="200"
                height="90"
                contain
                :src="require('@/assets/images/no-image.png')"
              ></v-img>
            </td>
            <td @click="updateDialog(promo, i)">{{ promo.bookmaker.name }}</td>
            <td @click="updateDialog(promo, i)">
              <!-- <div v-if="promo.states.length > 0">
                <span
                  v-for="(state, index) in promo.states"
                  :key="index"
                >
                  {{state.name}}
                  <span v-if="promo.states.length !== index +1">,</span>
                </span>

              </div>-->
              <div>
                <span
                  v-for="(state, index) in promo.bookmaker.states"
                  :key="index"
                >
                  {{state.name}}
                  <span v-if="promo.bookmaker.states.length !== index +1">,</span>
                </span>
              </div>
            </td>
            <td @click="updateDialog(promo, i)">
              <div v-if="promo.states.length > 0">
                <span
                  v-for="(state, index) in promo.states"
                  :key="index"
                >
                  {{state.name}}
                  <span v-if="promo.states.length !== index +1">,</span>
                </span>
              </div>
            </td>
            <td @click="updateDialog(promo, i)">{{ promo.header }}</td>
            <td @click="updateDialog(promo, i)">{{ promo.welcome_promo_position }}</td>
            <td>
              <v-menu
                transition="slide-x-transition"
                bottom
                right
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    class="hoverable"
                    v-bind="attrs"
                    v-on="on"
                  >mdi-dots-vertical</v-icon>
                </template>
                <v-list>
                  <v-list-item>
                    <v-list-item-title @click="triggerDelete(promo.id, i)">
                      <v-icon>mdi-delete</v-icon>Delete
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>
          </tr>
          <tr v-if="loadingMore">
            <td
              class="pl-0"
              v-for="n in 4"
              :key="n"
            >
              <v-skeleton-loader type="list-item" />
            </td>
          </tr>
        </tbody>
      </v-simple-table>
      <div
        v-if="listMeta.total"
        class="py-5 d-flex justify-center"
      >
        <small class="grey--text lighten-4">
          {{ listMeta.from }}-{{ listMeta.to }} of
          {{ listMeta.total | formatNumber }}
        </small>
      </div>
    </div>
    <div
      class="text-center mt-2 mb-8"
      v-if="listMeta.last_page > 1"
    >
      <v-pagination
        @input="pageChanged"
        :value="listMeta.current_page"
        :length="listMeta.last_page"
        :total-visible="10"
        circle
      ></v-pagination>
    </div>
    <v-overlay
      absolute
      :value="loading"
    >
      <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="300"
      >
        <v-card
          color="primary"
          dark
        >
          <v-card-text>
            {{ loading_message }}
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-overlay>
    <v-dialog
      v-model="showUpdateDialog"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Update Promo</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="form">
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                >
                  <v-text-field
                    outlined
                    label="Promo ID"
                    readonly
                    v-model="selectedPromo.id"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                >
                  <v-text-field
                    outlined
                    label="Outbound Link"
                    readonly
                    :value="webAppUrl + '/link/' + selectedPromo.bookmaker.slug + '/' + selectedPromo.id"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                >
                  <v-text-field
                    label="Promo title *"
                    required
                    outlined
                    :rules="rules.title"
                    v-model="selectedPromo.header"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                >
                  <v-text-field
                    outlined
                    :rules="rules.subTitle"
                    label="Promo Subtitle*"
                    v-model="selectedPromo.sub_header"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                >
                  <v-text-field
                    outlined
                    label="Offer Value"
                    v-model="selectedPromo.offer_value"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                >
                  <v-text-field
                    outlined
                    label="Promo Link*"
                    v-model="selectedPromo.affiliate_link"
                    hint="must be with 'https://' or 'http://'"
                    :rules="rules.link"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                >
                  <v-text-field
                    outlined
                    label="Conditions"
                    v-model="selectedPromo.welcome_condition_text"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                >
                  <v-text-field
                    outlined
                    label="Custom Promo Button Text"
                    v-model="selectedPromo.button_text"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                >
                  <v-select
                    :items="sports"
                    clearable
                    outlined
                    label="Sport"
                    v-model="sport"
                    @change="sportChanged"
                  ></v-select>
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                >
                  <v-autocomplete
                    :disabled="(sport == '' || typeof(sport) === 'undefined')"
                    :items="leagues"
                    clearable
                    outlined
                    multiple
                    label="League"
                    v-model="league"
                    :loading="loading_leagues"
                  ></v-autocomplete>
                </v-col>
                <!-- <v-col
                  cols="12"
                  sm="12"
                  md="12"
                >
                  <v-text-field
                    outlined
                    label="Match ID"
                    v-model="selectedPromo.match_id"
                  ></v-text-field>
                </v-col>-->
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                >
                  <v-textarea
                    outlined
                    name="input-7-4"
                    label="Promo Disclaimer"
                    v-model="selectedPromo.disclaimer_text"
                    hint="A default disclaimer will be used if none provided."
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="12"
                >
                  <v-autocomplete
                    multiple
                    :items="states_option"
                    clearable
                    dense
                    label="State"
                    v-model="us_states_id"
                  ></v-autocomplete>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="5"
                >
                  <v-checkbox
                    label="Welcome Promo"
                    v-model="selectedPromo.welcome_promo_flag"
                  ></v-checkbox>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="5"
                >
                  <v-text-field
                    outlined
                    label="Welcome Promo Priority"
                    type="number"
                    required
                    :rules="[ welcomePromoPriorityRules ]"
                    v-model="selectedPromo.welcome_promo_position"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="5"
                >
                  <v-checkbox
                    label="Bookie Review"
                    v-model="selectedPromo.bookie_review_flag"
                  ></v-checkbox>
                </v-col>
                <!-- <v-col
                  cols="12"
                  sm="6"
                  md="5"
                >
                  <v-autocomplete
                    multiple
                    :items="states_option"
                    class="custom"
                    clearable
                    dense
                    label="State"
                    v-model="us_states_id"
                  ></v-autocomplete>
                </v-col>-->
                <v-col
                  class="text-center"
                  cols="12"
                  md="12"
                >
                  <v-img
                    :src="logo_preview_url"
                    class="sportsbook-logo"
                    contain
                    v-if="logo_preview_url"
                  ></v-img>
                  <v-img
                    :src="require('@/assets/images/no-image.png')"
                    class="sportsbook-logo"
                    contain
                    v-else
                  ></v-img>
                  <input
                    @change="onLogoChange"
                    accept=".jpg, .jpeg, .png"
                    ref="logo"
                    style="display: none"
                    type="file"
                  />
                  <v-row>
                    <v-col
                      cols="12"
                      md="10"
                    >
                      <v-btn
                        @click="$refs.logo.click()"
                        block
                        class="upload-btn"
                        height="25"
                        small
                      >Custom Promo Image</v-btn>
                    </v-col>
                    <v-col
                      cols="12"
                      md="2"
                      class="text-left"
                      v-if="promo_logo"
                    >
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            @click="clearImage"
                            class="upload-btn"
                          >mdi-close</v-icon>
                        </template>
                        <span>clear image</span>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  class="mt-3"
                >
                  <v-text-field
                    outlined
                    label="Image Alt Text"
                    v-model="selectedPromo.image_alt_text"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  md="12"
                  class="text-left"
                >
                  <h4>Matches</h4>
                </v-col>
              </v-row>
              <v-row
                v-for="(matches, i) in selectedPromo.promo_matches"
                :key="i"
              >
                <v-col
                  cols="12"
                  md="10"
                  class="text-left match-row"
                >
                  <v-text-field
                    outlined
                    label="Match ID"
                    hint="sample Match ID - MLB_2020_5_OAK_LAA"
                    v-model="selectedPromo.promo_matches[i].match_id"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  md="2"
                  class="text-left"
                >
                  <v-icon
                    @click="removeSelectedPromoMatch(i)"
                    class="text-caption font-weight-bold header-btns remove-icon"
                  >mdi-close</v-icon>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  md="12"
                >
                  <b
                    @click="addSelectedPromoMatch"
                    class="text-caption font-weight-bold header-btns"
                  >Add Match</b>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="cancelUpdate"
          >Close</v-btn>
          <v-btn
            color="primary"
            class="text-color--white"
            @click="validateForm"
          >Update</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snackbar.show"
      right
      :color="snackbar.color"
    >
      {{ snackbar.message }}
      <v-btn
        text
        @click="snackbar.show = false"
      >OK</v-btn>
    </v-snackbar>
    <v-dialog
      v-model="confirmDeleteDialog"
      persistent
      max-width="360"
    >
      <v-card>
        <v-card-title class="headline">
          <p class="confirm-delete">Are you sure you want to delete this Promo?</p>
        </v-card-title>
        <v-card-text>Delete Promo.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="confirmDeleteDialog = false"
          >No</v-btn>
          <v-btn
            color="red darken-1 white--text"
            @click="triggerDeletePromo()"
          >Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import AppBarNavIcon from '@/layouts/shared/AppBarNavIcon'
import { mapState, mapActions } from 'vuex'
import debounce from 'lodash/debounce'
import { find, map } from 'lodash'

export default {
  name: 'SportsBooksWelcomePromo',

  components: {
    AppBarNavIcon
  },

  data () {
    return {
      webAppUrl: process.env.VUE_APP_WEB_URL,
      confirmDeleteDialog: false,
      loadingMore: false,
      loading: false,
      loading_message: 'Fetching Welcome Promos',
      filter: {
        search: ''
      },
      showSearch: false,
      showUpdateDialog: false,
      rules: {
        title: [v => !!v || 'Promo title is required'],
        subTitle: [v => !!v || 'Promo subtitle is required'],
        link: [v => !!v || 'Promo link is required']
      },
      selectedPromo: {
        header: '',
        sub_header: '',
        offer_value: '',
        welcome_promo_position: '',
        welcome_condition_text: '',
        affiliate_link: '',
        welcome_promo_flag: false,
        match_id: '',
        promo_matches: [],
        button_text: '',
        bookie_review_flag: false,
        disclaimer_text: '',
        image_alt_text: '',
        bookmaker: {
          slug: ''
        }
      },
      snackbar: {
        show: false,
        message: null,
        color: 'success'
      },
      states_option: [],
      us_states_id: [],
      to_delete_promo: null,
      to_delete_index: null,
      logo_preview_url: '',
      promo_logo: null,
      states_filter_id: '',
      book_filter_id: '',
      sportsbooks_option: [],
      location_filter: '',
      promo_location_filter: '',
      promo_states_filter_id: '',
      league_selector_loading: true,
      sport: '',
      league: [],
      loading_leagues: false,
      sports_options: [
        {
          text: 'Baseball',
          value: 'baseball'
        },
        {
          text: 'Basketball',
          value: 'basketball'
        },
        {
          text: 'Football',
          value: 'football'
        },
        {
          text: 'Golf',
          value: 'golf'
        },
        {
          text: 'Hockey',
          value: 'hockey'
        },
        {
          text: 'Soccer',
          value: 'soccer'
        },
        {
          text: 'Tennis',
          value: 'tennis'
        }
      ]
    }
  },

  computed: {
    ...mapState({
      usStates: state => state.usStates.list,
      requestStatus: state => state.bookMakerPromo.requestStatus,
      requestMsg: state => state.bookMakerPromo.requestMsg,
      promoList: state => state.bookMakerWelcomePromo.list,
      listMeta: state => state.bookMakerWelcomePromo.listMeta,
      sportsBooksList: state => state.bookmaker.list,
      leagues: state => map(state.tag.list, 'name'),
      sports: state => state.tag.sports
    })
  },

  methods: {
    ...mapActions({
      getStates: 'usStates/getStates',
      getPromoList: 'bookMakerWelcomePromo/getPromoList',
      getPromo: 'bookMakerPromo/getPromo',
      updatePromo: 'bookMakerPromo/updatePromo',
      deletePromo: 'bookMakerPromo/deletePromo',
      refreshList: 'bookMakerWelcomePromo/refreshList',
      updatePromoLogo: 'bookMakerPromo/updatePromoLogo',
      getBookList: 'bookmaker/getBookList',
      getTags: 'tag/getTags',
      getSportList: 'tag/getSports'
    }),

    async getSportData () {
      await this.getSportList()
    },

    async fetchUSStates (page = 1) {
      let params = { page }
      await this.getStates(params)
      let states = this.usStates

      states.forEach((value, key, map) => {
        this.states_option.push({
          text: value.name,
          value: value.id
        })
      })
    },
    async fetchPromoList (page = 1) {
      let params = { page }

      params.sort = 'welcome_promo_position'
      this.loading = true
      await this.getPromoList(params)
      this.loading = false
    },

    search: debounce(function () {
      this.fetchPromoList()
    }, 600),

    async updateDialog (promo, index) {
      this.loading = true
      this.loading_message = 'Fetching Promo Details'
      await this.getPromo(promo.id)
        .then(response => {
          this.selectedPromo = response.data
          this.us_states_id = map(response.data.states, 'id')
          if (response.data.promo_logo) {
            this.logo_preview_url = response.data.promo_logo.url
            this.selectedPromo.image_alt_text = response.data.promo_logo.custom_properties.alt_text
          }
          this.loading = false
        })
        .catch(err => {
          console.log(err)
        })

      this.showUpdateDialog = true
    },

    validateForm () {
      if (this.$refs.form.validate()) {
        this.loading = true
        this.loading_message = 'Updating Promo.'
        this.updateSelectedPromo()
      }
    },

    cancelUpdate () {
      this.selectedPromo = {
        header: '',
        sub_header: '',
        offer_value: '',
        welcome_promo_position: '',
        welcome_condition_text: '',
        affiliate_link: '',
        welcome_promo_flag: false,
        match_id: '',
        promo_matches: [],
        button_text: '',
        bookie_review_flag: false,
        disclaimer_text: '',
        image_alt_text: '',
        bookmaker: {
          slug: ''
        }
      }
      this.logo_preview_url = ''
      this.$refs.logo.value = null
      this.promo_logo = null
      this.showUpdateDialog = false
      this.league_selector_loading = true
      this.league = []
      this.sport = ''
    },

    async updateSelectedPromo () {
      this.showUpdateDialog = false
      let params = this.selectedPromo
      params.button_text = params.button_text ? params.button_text : 'Claim Now'
      params.us_states_id = this.us_states_id
      if (this.selectedPromo.promo_matches) {
        params.matches = []
        this.selectedPromo.promo_matches.map((match, i) => {
          if (match.match_id) params.matches.push(match.match_id)
        })
      }
      if (this.sport) {
        params.tag_type = this.sport
      }
      if (this.league) {
        params.tag_name = []
        this.league.map((l, i) => {
          if (l) params.tag_name.push(l)
        })
      }
      await this.updatePromo(params)

      if (this.promo_logo) {
        this.loading = true
        this.loading_message = 'Updating Promo Image'
        let logoFormData = new FormData()
        logoFormData.append('id', this.selectedPromo.id)
        logoFormData.append('promo_logo', this.promo_logo)
        logoFormData.append('image_alt_text', this.selectedPromo.image_alt_text)

        await this.updatePromoLogo(logoFormData)
        this.showSnackbar(this.requestMsg)
      }

      if (this.requestStatus === 'success') {
        this.showUpdateDialog = false
        this.sport = ''
        this.league = []
      } else {
        this.showUpdateDialog = true
      }
      this.showSnackbar(this.requestMsg)
      let fetchParams = { page: 1 }

      fetchParams.sort = 'welcome_promo_position'
      this.loading = true
      // this.refreshList()
      await this.getPromoList(fetchParams)
      this.clearImage()
      this.loading = false
    },

    async loadMore () {
      this.loadingMore = true

      if (this.listMeta.current_page < this.listMeta.last_page) {
        let params = { page: this.listMeta.current_page + 1 }
        params.sort = 'welcome_promo_position'

        await this.getPromoList(params)
      }
      this.loadingMore = false
    },

    showSnackbar (message) {
      this.snackbar.color = this.requestStatus
      this.snackbar.message = message
      this.snackbar.show = true
    },

    async triggerDeletePromo () {
      this.confirmDeleteDialog = false
      this.loading = true
      this.loading_message = 'Deleting Promo'

      await this.deletePromo(this.to_delete_promo)
        .then(response => {
          this.promoList.splice(this.to_delete_index, 1)
          this.showSnackbar(this.requestMsg)
          this.loading = false
        })
        .catch(err => {
          console.log(err)
        })
    },

    triggerDelete (id, index) {
      this.confirmDeleteDialog = true
      this.to_delete_promo = id
      this.to_delete_index = index
    },

    onLogoChange (e) {
      const file = e.target.files[0]
      this.logo_preview_url = URL.createObjectURL(file)
      this.promo_logo = file
    },
    clearImage () {
      this.$refs.logo.value = null
      this.promo_logo = null
      if (this.selectedPromo.promo_logo) {
        this.logo_preview_url = this.selectedPromo.promo_logo.url
      } else {
        this.logo_preview_url = ''
      }
    },

    async fetchSportsBookList (page = 1) {
      let params = { page }

      params.sort = '-created_at'
      params.per_page = 100
      this.loading = true
      await this.getBookList(params)

      let sportsBooks = this.sportsBooksList

      sportsBooks.forEach((value, key, map) => {
        let bookStates = ''
        value.states.forEach((state, key, map) => {
          if (value.states.length > 0) {
            bookStates += state.name
            if (value.states.length !== key + 1) {
              bookStates += ', '
            }
          }
        })

        let optionText = value.states.length > 0 ? value.name + ' (' + bookStates + ')' : value.name
        this.sportsbooks_option.push({
          text: optionText,
          value: value.id
        })
      })
      this.fetchPromoList()
      this.getSportData()
    },

    filterByState () {
      if (this.states_filter_id) {
        let location = find(this.states_option, ['value', this.states_filter_id])
        this.location_filter = location.text
        this.loading_message = `Fetching Promos for ${this.location_filter}`
      } else {
        this.location_filter = ''
        this.loading_message = `Fetching Promos`
      }
      this.filterSportBooks()
    },

    filterByPromoState () {
      if (this.promo_states_filter_id) {
        let location = find(this.states_option, ['value', this.promo_states_filter_id])
        this.promo_location_filter = location.text
        this.loading_message = `Fetching Promos for ${this.promo_location_filter}`
      } else {
        this.promo_location_filter = ''
        this.loading_message = `Fetching Promos`
      }
      this.filterSportBooks()
    },

    resetFilter () {
      this.location_filter = ''
      this.promo_location_filter = ''
      this.book_filter_id = ''
      this.states_filter_id = ''
      this.promo_states_filter_id = ''

      this.filterSportBooks()
    },

    async filterSportBooks (page = 1) {
      let params = { page }
      this.loading = true

      params.sort = 'welcome_promo_position'
      params.bookmakerOnlyStates = this.location_filter
      params.onlyStates = this.promo_location_filter
      params.onlySportsBook = this.book_filter_id

      // this.refreshList()
      await this.getPromoList(params)
      this.loading = false
      this.loading_message = `Fetching Promos`
    },

    pageChanged (page) {
      this.fetchPromoList(page)
    },

    welcomePromoPriorityRules (val) {
      if (val) {
        if (val < 1) {
          return 'Min priority number is 1'
        } else {
          return true
        }
      } else {
        return true
      }
    },

    removeSelectedPromoMatch (i) {
      this.selectedPromo.promo_matches.splice(i, 1)
    },

    addSelectedPromoMatch () {
      this.selectedPromo.promo_matches.push({
        match_id: ''
      })
    },

    async sportChanged () {
      this.league = []
      this.league_selector_loading = true
      // this.loading = true
      // this.loading_message = 'Fetching League List'
      try {
        this.loading_leagues = true
        if (this.sport) {
          await this.getTags({ withType: this.sport })
        }
      } catch (err) {
        console.log(err)
      } finally {
        this.loading_leagues = false
        this.league_selector_loading = false
        this.loading = false
      }
    },

    clearSport () {
      this.sport = ''
      this.league_selector_loading = true
      this.league = []
    }

  },

  created () {
    this.fetchUSStates()
    this.fetchSportsBookList()
  },

  filters: {
    formatNumber (value) {
      return Number(value).toLocaleString()
    }
  },

  watch: {
    selectedPromo (v) {
      if (typeof (v.tags) !== 'undefined') {
        if (v.tags.length > 0) {
          this.sport = v.tags[0].type.toLowerCase()
          this.league = map(v.tags, 'name')
          this.getTags({ withType: this.sport })
        }
      }
    }
  }
}
</script>

<style scoped>
.confirm-delete {
  word-break: initial;
}
.sportsbook-logo {
  width: 100%;
  height: 175px;
}
.upload-btn {
  border: 1px solid #df4661;
  color: #df4661;
  background-color: white !important;
}
.upload-btn:hover {
  color: white;
  background-color: #df4661 !important;
}
.header-btns {
  color: #df4661;
  cursor: pointer;
}
.remove-icon {
  font-size: 20px !important;
}
.match-row {
  padding: 0 !important;
}
</style>
